/**
 * Include or drop a key when projecting a record.
 */
export enum ProjectionModeEnum {
  PROJECT = 'project',
  OMIT = 'omit',
}
